import { j as t } from "./jsx-runtime-944c88e2.js";
import { v as a } from "./index-a0534bb4.js";
import { c as o } from "./form-2514c6d8.js";
import "react";
import "./index-efd35e77.js";
import "./index-93802845.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./index.es-6889c727.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./FloatingLabel-922c628f.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./Popup-b6c9078b.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./FormElement-65f04cfd.js";
const m = (r) => /* @__PURE__ */ t.jsx(a, { ...r, labelPlacement: "after", children: r.children }), q = ({ hint: r, validateOnSubmit: e, hasAttemptedSubmit: p, ...i }) => /* @__PURE__ */ t.jsx(o, { children: /* @__PURE__ */ t.jsx(m, { ...i }) }), w = ({
  validationMessage: r,
  touched: e,
  modified: p,
  visited: i,
  hint: c,
  fieldWrapperClassName: s,
  ...n
}) => /* @__PURE__ */ t.jsx(o, { className: s, children: /* @__PURE__ */ t.jsx(m, { ...n }) });
export {
  m as Checkbox,
  q as CheckboxFormField,
  w as FormElementCheckbox
};
